import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageAnnecy: React.FC = () => (
  <LocalSeoPage
    city="Annecy"
    slug="depannage-informatique-annecy"
    metaTitle="Dépannage informatique Annecy | Réparation PC | SOS IT"
    metaDescription="Technicien informatique à Annecy. Dépannage ordinateur, virus, Windows bloqué. Intervention rapide à domicile. Diagnostic gratuit."
    intro="Vous êtes à Annecy et votre ordinateur vous cause des ennuis ? Que ce soit un PC qui démarre plus, un virus tenace ou une connexion WiFi capricieuse, notre technicien intervient rapidement à domicile. Diagnostic gratuit, sans engagement, et un devis clair avant de commencer."
    postalCode="74000"
    cityFaqs={[
      { question: "Intervenez-vous à domicile à Annecy ?", answer: "Contactez-nous : nous vous indiquons si une intervention à domicile est possible selon notre planning, et nous confirmons le créneau à la prise de contact." },
      { question: "Dépannez-vous aussi à Cran-Gevrier, Seynod, Meythet ou Poisy ?", answer: "Oui, l'agglomération annécienne est couverte. Pour un déplacement à Cran-Gevrier, Seynod, Meythet, Poisy ou Pringy, appelez-nous ou écrivez sur WhatsApp pour convenir d'un créneau." },
    ]}
    nearbyTowns={[
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Cran-Gevrier' },
      { name: 'Seynod' },
      { name: 'Meythet' },
      { name: 'Poisy' },
      { name: 'Pringy' },
    ]}
    internalLinks={[
      { label: 'Création de site internet à Annecy', href: '/creation-site-internet-annecy' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique autour de Genève', href: '/depannage-informatique-geneve' },
    ]}
  />
);

export default DepannageAnnecy;
